import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { roleOf } from "@/lib/constants";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [clinics, setClinics] = useState([]);
  const [activeClinicId, setActive] = useState(localStorage.getItem("clinic") || "");

  const reloadClinics = useCallback(async () => {
    const { data } = await api.get("/clinics");
    setClinics(data);
    setActive((cur) => (data.find((c) => c.id === cur) ? cur : data[0]?.id || ""));
    return data;
  }, []);

  const boot = useCallback(async (u) => {
    setUser(u);
    if (u && roleOf(u) !== "super_admin") await reloadClinics().catch(() => setClinics([]));
  }, [reloadClinics]);

  useEffect(() => {
    api.get("/auth/me").then((r) => boot(r.data)).catch(() => setUser(false));
  }, [boot]);

  const signIn = async (path, body) => {
    const { data } = await api.post(path, body);
    localStorage.setItem("token", data.token);
    await boot(data.user);
    return data.user;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("token");
    localStorage.removeItem("clinic");
    setClinics([]);
    setUser(false);
  };

  const setActiveClinicId = (id) => {
    localStorage.setItem("clinic", id);
    setActive(id);
  };

  const activeClinic = clinics.find((c) => c.id === activeClinicId) || null;

  return (
    <AuthCtx.Provider value={{ user, clinics, activeClinic, activeClinicId: activeClinic?.id || "", setActiveClinicId,
      reloadClinics, login: (b) => signIn("/auth/login", b), register: (b) => signIn("/auth/register", b), logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
